import useTranslation from 'hooks/useTranslation';
import { useState } from 'react';
import { useEffect } from 'react';
import { runTimer } from 'tools/utils';

import style from './index.style';

export default function Timer() {
  const { TRANSLATIONS } = useTranslation();
  const timeZone = '+00:00';
  const [endDate, setEndDate] = useState('');
  useEffect(() => {
    const dataAttuale = new Date();
    const dataFutura = new Date(dataAttuale);
    dataFutura.setDate(dataAttuale.getDate() + 7);
    setEndDate(dataFutura.toISOString());
  }, []);

  const [timeLeft, setTimeLeft] = useState(runTimer(endDate, timeZone));
  useEffect(() => {
    const updateTimer = () => {
      setTimeLeft(runTimer(endDate, timeZone));
    };
    updateTimer();
    const intervalId = setInterval(updateTimer, 1000);
    return () => clearInterval(intervalId);
  }, [endDate, timeZone]);

  return (
    <div className={`d-f g-5 ai-c jc-c`}>
      <div className="time d-f ai-c jc-c fd-c">
        {timeLeft.days}
        <span>{TRANSLATIONS.promo.timer.days}</span>
      </div>
      <div className="time d-f ai-c jc-c fd-c">
        {timeLeft.hours}
        <span>{TRANSLATIONS.promo.timer.hours}</span>
      </div>
      <div className="time d-f ai-c jc-c fd-c">
        {timeLeft.minutes}
        <span>{TRANSLATIONS.promo.timer.minutes}</span>
      </div>
      <div className="time d-f ai-c jc-c fd-c">
        {timeLeft.seconds} <span>{TRANSLATIONS.promo.timer.seconds}</span>
      </div>
      <style jsx>{style}</style>
    </div>
  );
}
